<div
  class="w-full flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[url('/assets/images/Group_73.webp')] h-[230px] sm:h-[180px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-80"></div>
  <div
    class="grid xl:grid-cols-4 gap-y-3 items-center container px-3 md:px-0 mx-auto relative z-10"
  >
    <div>
      <button
        [routerLink]="['/account']"
        type="button"
        class="flex items-center text-white cursor-pointer"
      >
        <span class="mr-2">&larr;</span>
        <span>Dashboard</span>
      </button>
    </div>

    <div
      *ngIf="!outOfStep"
      class="xl:col-span-2 sm:w-fit w-full flex flex-col sm:items-center p-3 sm:p-0 space-y-2 sm:space-y-0 sm:flex-row bg-white shadow-md rounded-xl sm:rounded-full sm:h-[45px] overflow-hidden border"
    >
      <div
        class="flex items-center sm:ps-4 sm:py-2 sm:bg-blue-600 h-full z-40 relative sm:pe-8 text-blue-600 sm:text-white"
      >
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border bg-blue-600 text-white"
        >
          1
        </span>
        <span class="ml-2 font-medium">Listing Details</span>
      </div>

      <span
        class="me-3 text-gray-400 size-[34px] -ml-4 border-t border-r !border-white rotate-45 hidden sm:block bg-blue-600"
      ></span>

      <div class="flex items-center text-gray-400 sm:pe-4 sm:ps-2 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border !border-blue-600 text-blue-600"
        >
          2
        </span>
        <span class="ml-2 font-medium text-blue-500 text-sm">Add Photos</span>
      </div>

      <span
        class="mx-3 text-gray-400 size-[34px] -ml-2 border-t border-r !border-black/50 rotate-45 hidden sm:block"
      ></span>

      <div class="flex sm:items-center text-gray-400 sm:pe-4 sm:ps-2 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border"
        >
          3
        </span>
        <span class="ml-2 font-medium">Checkout</span>
      </div>
    </div>
    <p
      *ngIf="outOfStep"
      class="text-2xl sm:text:3xl lg:text-4xl font-extrabold text-center text-white"
    >
      Edit Images
    </p>

    <div class="justify-center items-center gap-5 hidden 2xl:flex">
      <out-button
        label="Save And Exit"
        [disabled]="isSavingToContinue || isSaving"
        [isLoading]="isSaving"
        loadingLabel="Saving"
        *ngIf="!outOfStep"
        (click)="Save()"
        buttonClass="!px-8 py-2 rounded-full border-2 !border-white text-white w-fit cursor-pointer duration-200 transition-all active:scale-95"
      >
      </out-button>

      <out-button
        [disabled]="isSavingToContinue || isSaving"
        label="Continue"
        loadingLabel="Saving"
        (clicked)="saveListingAndContinue()"
        *ngIf="!outOfStep"
        [isLoading]="isSavingToContinue"
        buttonClass="!px-8 py-2 rounded-full border-2 !border-[#1466C9] bg-[#1466C9] text-white w-fit cursor-pointer duration-200 transition-all active:scale-95"
      >
      </out-button>
    </div>
  </div>
</div>

<div
  *ngIf="!isLoadingInitialData"
  class="page-content pt-[15px] md:pb-[70px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div
    class="page-content-grid text-left container mx-auto pb-[1.6rem] w-full relative"
  >
    <div class="flex flex-wrap ml-[-1.6rem]">
      <div class="pt-[1.6rem] pl-[1.6rem] flex-grow flex-shrink basis-[100%]">
        <div>
          <div
            class="mb-12 border-yellow-600/50 bg-yellow-50/80 text-gray-900 p-4 rounded-lg border flex gap-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-yellow-600 flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

            <div>
              <h5 class="!mb-4 text-lg font-bold">
                What To Upload  [50 Images Max]
              </h5>
              <p class="text-gray-700 mb-3 text-sm">
                To verify your Tesla listing, please complete the steps below.
                This helps ensure your vehicle details are accurate and
                verified.
              </p>

              <ol class="list-decimal text-sm ps-4 space-y-3 text-gray-800">
                <li>
                  <h5 class="font-semibold">Upload clear photos of the vehicle:</h5>
                  <p class="text-gray-600 text-sm mt-1">
                    To ensure buyers have a comprehensive view of the car’s condition, please upload photos covering all major orientations of the vehicle. These should include:
                    <span class="font-medium">Front, Rear, Left, Right, Front Left (FL), Front Right (FR), Rear Left (RL),</span> and <span class="font-medium">Rear Right (RR)</span>.
                    Additional photos from other angles are welcome but be sure the key perspectives listed above are included.
                  </p>
                  <span class="text-gray-600 mt-1">NB: Capture all key angles of the vehicle </span>
                  <button
                    (click)="openModal('car')"
                    class="text-blue-600 underline text-sm hover:text-blue-800 cursor-pointer"
                  >
                    View example
                  </button>
                </li>

                <li>
                  <h5 class="font-semibold"
                    >Upload a screenshot from the Tesla app or
                    touchscreen:</h5
                  >
                  <p class="text-gray-600 text-sm mt-1">
                    Go to <em>Software</em> in the Tesla app or on the car’s
                    touchscreen and upload a screenshot showing the following:
                  </p>
                  <ul class="list-disc ps-5 mt-1 text-sm text-gray-700">
                    <li class="!mb-0.5">VIN</li>
                    <li class="!mb-0.5">Model/Trim</li>
                    <li class="!mb-0.5">FSD or Autopilot information</li>
                    <li class="!mb-0.5">Battery Health</li>
                  </ul>
                  <button
                    (click)="openModal('tesla')"
                    class="text-blue-600 underline text-sm hover:text-blue-800 cursor-pointer"
                  >
                    View example
                  </button>
                </li>
              </ol>
            </div>
            <div
              *ngIf="isModalOpen"
              class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3"
            >
              <div
                class="bg-white p-4 rounded-lg max-w-7xl w-full shadow-lg relative h-[90vh] overflow-hidden sm:h-auto"
              >
                <div class="w-full flex justify-end">
                  <button
                    (click)="closeModal()"
                    class="text-gray-500 hover:text-gray-700 text-xl font-bold mb-2 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-8"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                      />
                    </svg>
                  </button>
                </div>
                <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-4 h-full overflow-y-scroll">
                  <div *ngFor="let image of modalImages" class="relative">
                    <img
                      [src]="image.src"
                      alt="Example Image"
                      class="rounded w-full h-[270px] object-cover object-bottom"
                    />
                    <div
                      class="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-sm px-2 py-1 text-center rounded-b"
                    >
                      {{ image.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul
            class="edit-images__listing-info p-0 list-none grid sm:grid-cols-[1fr_1fr] border border-[#ccc] text-[18px] md:flex md:flex-row rounded-[.5rem]"
          >
            <li>
              <span>VIN #</span>
              {{ listing?.vehicle?.vin }}
            </li>
            <li>
              <span>Year</span>
              {{ listing?.vehicle?.year }}
            </li>
            <li>
              <span>Model</span>
              {{ listing?.vehicle?.model }}
            </li>
            <li>
              <span>Color</span>
              {{ listing?.vehicle?.specification?.colour }}
            </li>
            <li>
              <span>Condition</span>
              {{
                listing?.vehicle?.condition || 'Unknown' | capitalizeWithSpaces
              }}
            </li>
          </ul>
          <p
            class="leading-[1.45] font-[400] text-[14px] text-[#6c7884] my-[2rem]"
          >
            Please upload images that show your car from all angles. You can go
            back to the dashboard when you're done uploading images.
          </p>

          <!-- dropzone start -->
          <div
            class="custom-dropzone border-2 !border-black min-h-[250px] h-fit border-dashed rounded-lg p-6 cursor-pointer relative"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()"
            (keydown.enter)="fileInput.click()"
            (keydown.space)="fileInput.click()"
            tabindex="0"
            role="button"
            [ngClass]="{ 'bg-gray-200': isDragging }"
          >
            <!-- Hide label when files are present -->
            <div *ngIf="files.length === 0" class="text-center h-[210px]">
              <div
                class="!h-full w-full flex flex-col justify-center items-center"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                  class="size-10 text-black"
                >
                  <path
                    fill="currentColor"
                    d="M528 288H384v-32h64c42.6 0 64.2-51.7 33.9-81.9l-160-160c-18.8-18.8-49.1-18.7-67.9 0l-160 160c-30.1 30.1-8.7 81.9 34 81.9h64v32H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80L288 48l160 160H336v160h-96V208H128zm400 256H48V336h144v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-32h144v128zm-40-64c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24z"
                  ></path>
                </svg>
                <h3 class="font-semibold sm:text-lg">
                  Drag and drop to upload images
                </h3>
                <p class="text-sm text-gray-600">
                  or, click to select images from your device.
                </p>
              </div>
            </div>

            <!-- Image grid -->
            <div
              *ngIf="files.length > 0"
              class="flex justify-start items-start gap-3 flex-wrap mt-2"
            >
              <div *ngFor="let file of files" class="group">
                <div
                  class="w-fit h-fit relative"
                  tabindex="0"
                  (keydown.enter)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                >
                  <img
                    [src]="file.preview"
                    [alt]="file.name"
                    class="w-[200px] h-[200px] object-cover rounded"
                  />

                  <!-- Overlay for status -->
                  <div
                    *ngIf="file.status"
                    class="absolute inset-0 bg-black/50 flex items-center justify-center rounded transition-opacity duration-300"
                    [ngClass]="{
                      'bg-green-500/50 backdrop-blur-lg':
                        file.status === 'success',
                      'bg-red-500/50 backdrop-blur-sm': file.status === 'error',
                      'bg-blue-500/50 backdrop-blur-sm':
                        file.status === 'uploading'
                    }"
                  >
                    <!-- Loading spinner for uploading -->
                    <div
                      *ngIf="file.status === 'uploading'"
                      class="animate-spin"
                    >
                      <svg
                        class="w-8 h-8 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    </div>

                    <!-- Success check mark -->
                    <svg
                      *ngIf="file.status === 'success'"
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-8 text-white"
                      viewBox="0 0 24 24"
                    >
                      <g fill="currentColor">
                        <path
                          d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12m11 9a9 9 0 1 1 0-18a9 9 0 0 1 0 18"
                          clip-rule="evenodd"
                        />
                      </g>
                    </svg>

                    <!-- Error X mark -->
                    <svg
                      *ngIf="file.status === 'error'"
                      class="w-8 h-8 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </div>

                  <!-- Existing remove button -->
                  <button
                    class="absolute top-1 right-1 bg-red-500 text-white text-xs rounded-full flex justify-center items-center p-1.5 opacity-80 hover:opacity-100 cursor-pointer"
                    (click)="removeFile(file, $event)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-4"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <input
              type="file"
              #fileInput
              class="hidden"
              (change)="onFileSelect($event)"
              accept="image/*"
              multiple
            />
          </div>

          <div *ngIf="files.length === 0 && !errorMessage" class="text-start">
            <!-- ...existing content... -->
            <p class="text-sm text-gray-600 mt-2">
              Maximum {{ MAX_FILES }} images, up to 15MB each
            </p>
          </div>
          <p *ngIf="errorMessage" class="text-red-500 text-sm mt-2">
            {{ errorMessage }}
          </p>
          <!-- dropzone end -->

          <div
            [ngClass]="outOfStep ? 'lg:grid-cols-3' : 'sm:grid-cols-2'"
            class="grid gap-5 mt-10"
          >
            <out-button
              label="Save And Exit"
              [disabled]="isSavingToContinue || isSaving || isUploading"
              [isLoading]="isSaving"
              loadingLabel="Saving"
              *ngIf="!outOfStep"
              (click)="Save()"
              buttonClass="!w-full px-3 rounded-lg border-2 !border-[#1466C9] text-[#1466C9] w-full cursor-pointer duration-200 transition-all active:scale-95 font-semibold py-4"
            >
            </out-button>
            <out-button
              [disabled]="isSavingToContinue || isSaving || isUploading"
              label="Save And Continue"
              loadingLabel="Saving"
              (clicked)="saveListingAndContinue()"
              *ngIf="!outOfStep"
              [isLoading]="isSavingToContinue"
              buttonClass="px-3 rounded-lg border-2 bg-[#1466C9] text-white !w-full cursor-pointer duration-200 transition-all active:scale-95 font-semibold py-4"
            >
            </out-button>
            <out-button
              [disabled]="isSavingToContinue || isSaving"
              label="Save Images"
              loadingLabel="Saving"
              (clicked)="Save()"
              *ngIf="outOfStep"
              [isLoading]="isSaving"
              buttonClass="px-3 rounded-lg border-2 bg-[#1466C9] text-white !w-full cursor-pointer duration-200 transition-all active:scale-95 font-semibold py-4"
            >
            </out-button>
          </div>
          <p
            class="mt-[1rem] text-[#222] m-[0_0_1rem] leading-[1.45] font-[400] text-[14px]"
          >
            If you don't have images to hand right now, you may return to this
            listing later in your
            <a routerLink="/account" class="text-[#3186d0] underline"
              >dashboard</a
            >.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- skeleton -->
<div
  *ngIf="isLoadingInitialData"
  class="page-content pt-[15px] md:pb-[70px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div
    class="page-content-grid text-left container mx-auto pb-[1.6rem] w-full relative overflow-hidden"
  >
    <div class="flex flex-wrap ml-[-1.6rem]">
      <div class="pt-[1.6rem] pl-[1.6rem] flex-grow flex-shrink basis-[100%]">
        <div>
          <div
            class="mb-[1.5rem] text-[#000] m-[2rem_0_1rem] w-[150px] h-[30px] bg-[#e1e5e8] rounded-sm skeleton-shimmer relative"
          ></div>
          <ul
            class="edit-images__listing-info m-[0_0_4rem] p-0 list-none grid grid-cols-[1fr_1fr_1fr] border border-[#ccc] text-[18px] md:flex md:flex-row rounded-[.5rem] skeleton-shimmer relative"
          >
            <li>
              <span class="w-[80px] h-[20px] bg-[#e1e5e8] rounded-sm"></span>
              <p class="w-[150px] h-[23px] bg-[#e1e5e8] rounded-sm"></p>
            </li>
            <li>
              <span class="w-[80px] h-[20px] bg-[#e1e5e8] rounded-sm"></span>
              <p class="w-[150px] h-[23px] bg-[#e1e5e8] rounded-sm"></p>
            </li>
            <li>
              <span class="w-[80px] h-[20px] bg-[#e1e5e8] rounded-sm"></span>
              <p class="w-[150px] h-[23px] bg-[#e1e5e8] rounded-sm"></p>
            </li>
            <li>
              <span class="w-[80px] h-[20px] bg-[#e1e5e8] rounded-sm"></span>
              <p class="w-[150px] h-[23px] bg-[#e1e5e8] rounded-sm"></p>
            </li>
            <li>
              <span class="w-[80px] h-[20px] bg-[#e1e5e8] rounded-sm"></span>
              <p class="w-[150px] h-[23px] bg-[#e1e5e8] rounded-sm"></p>
            </li>
          </ul>
          <p
            class="m-[0_0_1rem] mb-[2rem] h-[30px] bg-[#e1e5e8] rounded-sm skeleton-shimmer relative"
          ></p>
          <div class="w-full h-[200px] border p-3 rounded-lg">
            <div
              class="w-full h-full skeleton-shimmer relative bg-[#e1e5e8] rounded-lg"
            ></div>
          </div>
          <div
            [ngClass]="outOfStep ? 'lg:grid-cols-3' : 'grid-cols-2'"
            class="grid gap-5 mt-10"
          >
            <div
              *ngIf="!outOfStep"
              class="h-[50px] bg-[#e1e5e8] rounded-sm skeleton-shimmer relative"
            ></div>
            <div
              *ngIf="!outOfStep"
              class="h-[50px] bg-[#e1e5e8] rounded-sm skeleton-shimmer relative"
            ></div>
            <div
              *ngIf="outOfStep"
              class="h-[50px] bg-[#e1e5e8] rounded-sm skeleton-shimmer relative"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<out-alert></out-alert>
